import CustomModalBody from "components/Modal/body";
import CustomModalFooter from "components/Modal/footer";
import { useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

export default function FilterForm({ onSubmit, onChangeHOC, handleState }) {
	const [invoiceStartDate, setInvoiceStartDate] = useState(null);
	const [invoiceEndDate, setInvoiceEndDate] = useState(null);
	const [activatedDate, setActivatedDate] = useState("");
	const [transInvoice, setTransInvoice] = useState("");
	const [postID, setPostID] = useState("");
	const [orderNo, setOrderNo] = useState("");
	const [advertiser, setAdvertiser] = useState("");
	const [invoiceNumber, setInvoiceNumber] = useState("");
	const [agentLeadID, setAgentLeadID] = useState("");
	const [promoCode, setPromoCode] = useState("");
	const [agentID, setAgentID] = useState("");
	const [agentName, setAgentName] = useState("");
	const [agentLeadName, setAgentLeadName] = useState("");
	const [startDateOfEditing, setStartDateOfEditing] = useState("");
	const [endDateOfEditing, setEndDateOfEditing] = useState("");
	const [priceAfterTax, setPriceAfterTax] = useState("");
	const [sellingPrice, setSellingPrice] = useState("");

	const handleClear = () => {
		setInvoiceStartDate("");
		setInvoiceEndDate("");
		setAdvertiser("");
		setInvoiceNumber("");
		setAgentName("");
		setActivatedDate("");
		setTransInvoice("");
		setAgentLeadID("");
		setPromoCode("");
		setPostID("");
		setOrderNo("");
		setAgentLeadName("");
		setAgentID("");
		setStartDateOfEditing("");
		setEndDateOfEditing("");
		setPriceAfterTax("");
		setSellingPrice("");
	};

	const generateQuery = () => {
		let queryString = "";

		if (invoiceStartDate){ queryString += `&invoice_start_date=${invoiceStartDate}`}
		if (invoiceEndDate){ queryString += `&invoice_end_date=${invoiceEndDate}`}
		if (postID){ queryString += `&jobads_id=${postID}`}
		if (orderNo){ queryString += `&order_no=${orderNo}`}
		if (agentName){ queryString += `&agent_name=${agentName}`}
		if (agentLeadID){ queryString += `&agent_code=${agentLeadID}`}
		if (agentLeadName){ queryString += `&last_edit_user=${agentLeadName}`}
		if (advertiser){ queryString += `&advertiser_name=${advertiser}`}
		if (transInvoice){ queryString += `&invoice_date=${transInvoice}`}
		if (startDateOfEditing){ queryString += `&start_date_of_editing=${startDateOfEditing}`}
		if (endDateOfEditing){ queryString += `&end_date_of_editing=${endDateOfEditing}`}
		if (priceAfterTax){ queryString += `&price_after_tax=${priceAfterTax}`}
		if (sellingPrice){ queryString += `&selling_price=${sellingPrice}`}
		// havent support activate date
		// if (activatedDate){ queryString += `&activated_date=${activatedDate}`}

		return queryString;
	};

	return (
		<>
			<CustomModalBody>
				<Form id="billing-filter-form">
					<Row>
						{/* <Col lg={3}>
							<FormGroup>
								<Label for="invoiceStartDate">Invoice Start Date </Label>
								<Input
									type="date"
									placeholder="Enter Start Date"
									name="invoiceStartDate"
									id="invoiceStartDate"
									value={invoiceStartDate}
									onChange={(e) => {setInvoiceStartDate(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="invoiceEndDate">Invoice End Date </Label>
								<Input
									type="date"
									placeholder="Enter "
									name="invoiceEndDate"
									id="invoiceEndDate"
									value={invoiceEndDate}
									onChange={(e) => {setInvoiceEndDate(e.target.value)}}
								/>
							</FormGroup>
						</Col> */}
						<Col lg={3}>
							<FormGroup>
								<Label for="setStartDateOfEditing">Start Date Of Editing </Label>
								<Input
									type="date"
									placeholder="Enter Start Date Of Editing"
									name="setStartDateOfEditing"
									id="setStartDateOfEditing"
									value={startDateOfEditing}
									onChange={(e) => {setStartDateOfEditing(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="setEndDateOfEditing">End Date Of Editing </Label>
								<Input
									type="date"
									placeholder="Enter End Date Of Editing"
									name="setEndDateOfEditing"
									id="setEndDateOfEditing"
									value={endDateOfEditing}
									onChange={(e) => {setEndDateOfEditing(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="postID">Post ID </Label>
								<Input
									placeholder="Enter Post ID"
									name="postID"
									id="postID"
									value={postID}
									onChange={(e) => {setPostID(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="orderNo">Order No. </Label>
								<Input
									placeholder="Enter Order No."
									name="orderNo"
									id="orderNo"
									value={orderNo}
									onChange={(e) => {setOrderNo(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						{/* <Col lg={3}>
							<FormGroup>
								<Label for="transInvoice">Invoice Date</Label>
								<Input
									type="date"
									placeholder="Enter Invoice Date"
									name="transInvoice"
									id="transInvoice"
									value={transInvoice}
									onChange={(e) => {setTransInvoice(e.target.value)}}
								/>
							</FormGroup>
						</Col> */}

						<Col lg={3}>
							<FormGroup>
								<Label for="advertiser">Advertiser Name </Label>
								<Input
									placeholder="Enter Advertiser Name"
									name="advertiser"
									id="advertiser"
									value={advertiser}
									onChange={(e) => {setAdvertiser(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						{/* <Col lg={3}>
							<FormGroup>
								<Label for="sprice">Selling Price</Label>
								<Input
									placeholder="Enter Selling Price"
									name="sprice"
									id="sprice"
									value={sellingPrice}
									onChange={(e) => {setSellingPrice(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="priceat">Price After Tax</Label>
								<Input
									placeholder="Enter Price After Tax"
									name="priceat"
									id="priceat"
									value={priceAfterTax}
									onChange={(e) => {setPriceAfterTax(e.target.value)}}
								/>
							</FormGroup>
						</Col> */}
						<Col lg={3}>
							<FormGroup>
								<Label for="agentLeadName">Last Editing User (Admin) </Label>
								<Input
									placeholder="Enter Last Editing User (Admin)"
									name="agentLeadName"
									id="agentLeadName"
									value={agentLeadName}
									onChange={(e) => {setAgentLeadName(e.target.value)}}
								/>
							</FormGroup>
						</Col>						
						<Col lg={3}>
							<FormGroup>
								<Label for="agentLeadID">Agent Code </Label>
								<Input
									placeholder="Enter Agent Code"
									name="agentLeadID"
									id="agentLeadID"
									value={agentLeadID}
									onChange={(e) => {setAgentLeadID(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="agentName">Agent Name</Label>
								<Input
									placeholder="Enter Agent"
									name="agentName"
									id="agentName"
									value={agentName}
									onChange={(e) => {setAgentName(e.target.value)}}
								/>
							</FormGroup>
						</Col>
					</Row>
				</Form>
			</CustomModalBody>
			<CustomModalFooter
				rightButton={[
					{
						color: "danger",
						outline: true,
						content: "Clear All",
						onClick: () => handleClear(),
					},
					{
						color: "primary",
						content: "Submit",
						onClick: () => {
							const queryString = generateQuery();
							onSubmit(queryString);
							handleState({ filterQuery: queryString });
							onChangeHOC("showFilterModal", false);
							onChangeHOC("advertiserPages", 1);
						},
					},
				]}
			/>
		</>
	);
}
